import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-target-frame-svg',
  standalone: true,
  template: `
    <svg width="134" height="141" viewBox="0 0 134 141" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g style="mix-blend-mode:plus-lighter" filter="url(#filter0_f_target_frame)">
        <path d="M59.6941 4.78278L6.8112 36.0455C5.6107 36.7552 4.87423 38.0461 4.87423 39.4407V63.1167"
              [attr.stroke]="color()" stroke-width="1.31471"/>
      </g>
      <g style="mix-blend-mode:plus-lighter">
        <path d="M59.6941 4.78278L6.8112 36.0455C5.6107 36.7552 4.87423 38.0461 4.87423 39.4407V63.1167"
              [attr.stroke]="color()" stroke-opacity="0.5" stroke-width="1.31471"/>
      </g>
      <g style="mix-blend-mode:plus-lighter" filter="url(#filter1_f_target_frame)">
        <path d="M60.397 135.507L7.51409 104.244C6.31358 103.535 5.57711 102.244 5.57711 100.849V77.1731"
              [attr.stroke]="color()" stroke-width="1.31471"/>
      </g>
      <g style="mix-blend-mode:plus-lighter">
        <path d="M59.6941 135.507L6.8112 104.244C5.6107 103.535 4.87423 102.244 4.87423 100.849V77.1731"
              [attr.stroke]="color()" stroke-opacity="0.5" stroke-width="1.31471"/>
      </g>
      <g style="mix-blend-mode:plus-lighter" filter="url(#filter2_f_target_frame)">
        <path d="M73.6367 4.78278L126.52 36.0455C127.72 36.7552 128.457 38.0461 128.457 39.4407V63.1167"
              [attr.stroke]="color()" stroke-width="1.31471"/>
      </g>
      <g style="mix-blend-mode:plus-lighter">
        <path d="M73.6367 4.78278L126.52 36.0455C127.72 36.7552 128.457 38.0461 128.457 39.4407V63.1167"
              [attr.stroke]="color()" stroke-opacity="0.5" stroke-width="1.31471"/>
      </g>
      <g style="mix-blend-mode:plus-lighter" filter="url(#filter3_f_target_frame)">
        <path d="M72.9341 135.507L125.817 104.244C127.017 103.535 127.754 102.244 127.754 100.849V77.1731"
              [attr.stroke]="color()" stroke-width="1.31471"/>
      </g>
      <g style="mix-blend-mode:plus-lighter">
        <path d="M73.1431 135.729L126.026 104.466C127.226 103.756 127.963 102.465 127.963 101.071V77.3947"
              [attr.stroke]="color()" stroke-opacity="0.5" stroke-width="1.31471"/>
      </g>
      <defs>
        <filter id="filter0_f_target_frame" x="-0.000114918" y="-8.10623e-06" width="64.2456" height="67.3336"
                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="2.10846" result="effect1_foregroundBlur"/>
        </filter>
        <filter id="filter1_f_target_frame" x="0.702766" y="72.9562" width="64.2456" height="67.3336"
                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="2.10846" result="effect1_foregroundBlur"/>
        </filter>
        <filter id="filter2_f_target_frame" x="69.0853" y="-8.10623e-06" width="64.2456" height="67.3336"
                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="2.10846" result="effect1_foregroundBlur"/>
        </filter>
        <filter id="filter3_f_target_frame" x="68.3827" y="72.9562" width="64.2456" height="67.3336"
                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="2.10846" result="effect1_foregroundBlur"/>
        </filter>
      </defs>
    </svg>
  `,
  styles: [`
    :host {
      display: block;
    }
    svg {
      display: block;
      width: 100%;
      height: auto;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TargetFrameSvgComponent {
  readonly color = input.required<string>();
}
